import {
  DatabaseService,
  SpecialAttribute,
  SpecialAttributeData,
  SpecialAttributeRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getSpecialAttributeRepository(
  databaseService: DatabaseService,
): SpecialAttributeRepository {
  return getGenericRepository<SpecialAttribute, SpecialAttributeData>(
    () => DatabaseCollection.SPECIAL_ATTRIBUTES,
    databaseService,
  );
}
